<mat-card *ngIf="enabled" data-testid="form-level-details">
  <ng-container *ngIf="expanded; else collapsed">
    <form data-testid="expanded" [formGroup]="formGroup">
      <div class="flex-row flex-gap">
        <assess-lookup-search
          *ngIf="riskConfig?.formProviderEnabled"
          class="flex-66"
          formControlName="provider"
          assessProviderSearch
        >
        </assess-lookup-search>
        <assess-date-of-service
          *ngIf="riskConfig?.formDosEnabled"
          class="flex-33"
          [dateOfServiceMinMax]="dateOfServiceMinMax"
          controlName="dateOfService"
        >
        </assess-date-of-service>
      </div>
      <div class="flex-row flex-row-gap">
        <button
          mat-flat-button
          color="primary"
          data-testid="form-level-details-save-button"
          [disabled]="saveDisabled"
          (click)="save()"
        >
          Save
        </button>
        <button mat-button color="primary" data-testid="form-level-cancel" (click)="cancel()">Cancel</button>
      </div>
    </form>
  </ng-container>
</mat-card>

<ng-template #collapsed>
  <div data-testid="collapsed" class="layout-container">
    <div class="collapsed" *ngIf="riskConfig?.formProviderEnabled">
      <img src="assets/icon/provider-icon.svg" />
      <span class="bold">Provider</span>
      <span>{{ provider | empty: '-' }}</span>
    </div>
    <div class="collapsed" *ngIf="riskConfig?.formDosEnabled">
      <img src="assets/icon/dos-icon.svg" />
      <span class="bold">Date of Service</span>
      <span>{{ formGroup.get('dateOfService')?.value | formatDate | empty: '-' }}</span>
    </div>

    <div>
      <div *ngIf="review && !formGroup.valid" class="incomplete" data-testid="incomplete">
        <mat-icon class="error custom-mat-icon-1">warning</mat-icon>
        <span class="error">Incomplete</span>
      </div>
      <button mat-button color="primary" (click)="edit()">
        <mat-icon class="custom-mat-icon-1">edit</mat-icon>
        Edit
      </button>
    </div>
  </div>
</ng-template>
